import React, { memo, useMemo, useState } from "react";
import ContentBlock from "../../../components/ContentBlock/ContentBlock";
import DefaultTable from "../../../components/table/DefaultTable";
import { COLUMNS } from "../../../columns";
import { useBlogsQuery } from "../../../hooks/blogs/query/useBlogs.query";
import { CONSTANTS } from "../../../constants";
import ActionButton from "./components/ActionButton";
import { Button } from "@mantine/core";
import { useNavigate } from "react-router-dom";

const Blogs = () => {
  const navigate = useNavigate();
  const columns = [...COLUMNS.BLOGS];
  const [activePage, setActivePage] = useState(1);
  const [pagedData, setPagedData] = useState({ total: 0 });

  const { data, isLoading, refetch } = useBlogsQuery({
    itemPerPage: CONSTANTS.PAGE_LIMIT,
    page: activePage,
  });

  const banners = useMemo(() => {
    if (!isLoading && data?.status === "success") {
      data?.pageData && setPagedData(data.pageData);
      return data.data;
    } else {
      return [];
    }
  }, [isLoading, data]);

  columns.push({
    label: "Actions",
    key: "actions",
    renderCell: (row) => (
      <ActionButton
        data={row}
        refetch={refetch}
        onEditClick={(id) => navigate(`/blogs-page/blogs/edit/${id}`)}
      />
    ),
  });

  return (
    <ContentBlock
      title="Blogs"
      loading={false}
      rightComponent={
        <Button
          onClick={() => navigate("/blogs-page/blogs/add-blogs")}
          variant="filled"
          color="blue"
        >
          Add Banner
        </Button>
      }
    >
      <DefaultTable
        columns={columns as TTableColumns<unknown>[]}
        data={banners}
        isLoading={isLoading}
        paginationProps={{
          setPage: setActivePage,
          totalPages: pagedData.total,
        }}
      />
    </ContentBlock>
  );
};

export default memo(Blogs);
